import { CountryData, initialCountryData } from "./Country";
import { CountyData, initialCountyData } from "./County";

export interface AddressData {
  id: number;
  street: string;
  city: string;
  region: string | null;
  countyId: string | null;
  countryId: String;
  postalCode: string;
  userId: number;
  county: CountyData;
  country: CountryData;
}

export const initialAddressData: AddressData = {
  id: 0,
  street: "",
  city: "",
  region: null,
  countyId: null,
  countryId: "LR",
  postalCode: "",
  userId: 0,
  county: initialCountyData,
  country: initialCountryData,
};
